import { SupportedLanguageCodes } from '@app-static-data/languages';

import { GetProductsRequest } from './product.request';

export class AggregatorRequest {
  vin: string;
  saleDate: string;
  odometer: number;
  financeType: string;
  vehicleMake: string;
  vehicleModel: string;
  groupCode: string;
  financeAmount: number;
  vehicleCost: number;
  vehicleMSRP: number;
  lienholderName: string;
  languageCode: 'en_US' | 'en_CA' | 'fr_CA';
  inServiceDate?: string;
  isAfterSale?: string;
  vehiclePurchaseDate?: string;
  programName?: string;
  vehicleYear?: number;
  vehicleTrim?: string;
  vehicleCondition?: string;
  customerState?: string;

  constructor(request: GetProductsRequest, languageCode: SupportedLanguageCodes) {
    this.vin = request.vin;
    this.saleDate = this.formatDate(request.saleDate);
    this.odometer = +request.odometer;
    this.financeType = request.financeType;
    this.vehicleMake = request.vehicleMake;
    this.vehicleModel = request.vehicleModel;
    this.financeAmount = +request.financeAmount;
    this.vehicleCost = +request.vehicleCost;
    this.vehicleMSRP = +request.vehicleMSRP;
    this.lienholderName = request.lienholderName;
    this.languageCode = this.formatLanguageCode(languageCode);

    this.groupCode = '';

    // Optional props:
    if (request.inServiceDate) {
      this.inServiceDate = this.formatDate(request.inServiceDate);
    }
    if (request.isAfterSale) {
      this.isAfterSale = request.isAfterSale;
    }
    if (request.vehiclePurchaseDate) {
      this.vehiclePurchaseDate = this.formatDate(request.vehiclePurchaseDate);
    }
    if (request.programName) {
      this.programName = request.programName;
    }
    if (request.vehicleYear) {
      this.vehicleYear = +request.vehicleYear;
    }
    if (request.vehicleTrim) {
      this.vehicleTrim = request.vehicleTrim;
    }
    if (request.vehicleCondition) {
      this.vehicleCondition = request.vehicleCondition;
    }
    if (request.customerState) {
      this.customerState = request.customerState;
    }
  }

  private formatDate(date: string): string {
    const dateObj = new Date(date);

    const year = dateObj.getFullYear();

    const month = dateObj.getMonth() + 1;
    const formattedMonth = month < 10 ? '0' + month : month;

    const day = dateObj.getDate();
    const formattedDay = day < 10 ? '0' + day : day;

    return `${year}/${formattedMonth}/${formattedDay}`;
  }

  private formatLanguageCode(lang: SupportedLanguageCodes): 'en_US' | 'en_CA' | 'fr_CA' {
    switch (lang) {
      default:
      case SupportedLanguageCodes.EnglishCA:
        return 'en_CA';
      case SupportedLanguageCodes.French:
        return 'fr_CA';
      case SupportedLanguageCodes.English:
        return 'en_US';
    }
  }
}
